import React from "react";
import { ScrollText, Recycle, Award } from "lucide-react";

const REGULATIONS = [
  { name: "GDPR / UK GDPR", note: "The “right to erasure” and secure-disposal obligations." },
  { name: "HIPAA", note: "Media sanitization for protected health information." },
  { name: "PCI DSS", note: "Secure deletion of cardholder data before reuse or resale." },
  { name: "ISO/IEC 27001", note: "Secure disposal and re-use of equipment controls." },
];

const Compliance = () => {
  return (
    <section id="compliance" className="relative bg-white font-body">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:py-28">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-line bg-brand-bg px-3.5 py-1.5 text-xs font-medium uppercase tracking-[0.16em] text-brand-plum">
            Compliance
          </span>
          <h2 className="mt-5 font-display text-3xl font-semibold leading-tight tracking-tight text-brand-plum sm:text-4xl lg:text-5xl">
            Evidence Auditors <span className="text-brand-gradient">Actually Ask For</span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-ink sm:text-lg">
            Documented, verifiable erasure is a requirement under the major data-protection and industry
            regimes. The signed certificate produced for every device is the proof these frameworks ask for.
          </p>
        </div>

        {/* regulations */}
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {REGULATIONS.map(({ name, note }) => (
            <div key={name} className="rounded-2xl border border-line bg-white p-5">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-brand-wash text-brand-magenta ring-1 ring-brand-orchid/30">
                <ScrollText className="h-5 w-5" />
              </span>
              <h3 className="mt-3 font-display text-base font-semibold text-brand-plum">{name}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-muted">{note}</p>
            </div>
          ))}
        </div>

        {/* refurb programs + road to certification */}
        <div className="mt-8 grid gap-5 lg:grid-cols-2">
          <div className="flex items-start gap-4 rounded-2xl border border-brand-orchid/30 bg-brand-wash/60 p-6">
            <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white text-brand-magenta ring-1 ring-brand-orchid/30">
              <Recycle className="h-5 w-5" />
            </span>
            <div>
              <h3 className="font-display text-base font-semibold text-brand-plum">
                Refurbishment &amp; recycling
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-muted">
                Our documented, verifiable erasure process supports the data-security requirements of leading
                programs such as <span className="font-medium text-brand-plum">R2v3</span> and{" "}
                <span className="font-medium text-brand-plum">e-Stewards</span>.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-4 rounded-2xl border border-line bg-white p-6">
            <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-wash text-brand-magenta ring-1 ring-brand-orchid/30">
              <Award className="h-5 w-5" />
            </span>
            <div>
              <h3 className="font-display text-base font-semibold text-brand-plum">
                On the road to certification
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-muted">
                Today Furloop Poofed <span className="font-medium text-brand-plum">conforms to</span> the
                standards above — our methods, read-back verification, and signed certificates are built to
                satisfy them. We are not yet independently certified by a governing body; our first target is{" "}
                <span className="font-medium text-brand-plum">ADISA</span>, with broader approvals to follow.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Compliance;
